var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": _vm.appliesOtherCompany,
        label: "他社求人への応募",
      },
    },
    [
      _c("label", { staticClass: "boss-checkbox" }, [
        _c("input", {
          staticClass: "boss-input-checkbox",
          attrs: { type: "checkbox", "data-test": "applies-other-company" },
          domProps: { checked: _vm.appliesOtherCompany },
          on: {
            change: function ($event) {
              return _vm.$emit(
                "update:appliesOtherCompany",
                $event.target.checked
              )
            },
          },
        }),
        _vm._v("他社の求人へ応募済みの会員を除外\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }